import http from '../jslibs/axios/http';
import dkAxiosFile from '@/jslibs/axios/axios-file';

export const login = (data) => (http.post('/v1/cms/Login', data));

//获取所有菜单项
export const menulist = () => (http.get('/v1/cms/AdminAuthMenu'));

//获取七牛信息
export const qiniuInfo = () => (http.get('/v1/app/Communal'))


//上传图片
// export const uploadImg = (data)=> http.post('http(s)://upload-z2.qiniup.com', data)

export const uploadImg = data => dkAxiosFile({
  url: 'https://upload-z2.qiniup.com',
  headers: {
    'content-type': 'multipart/form-data',
  },
  method: 'POST',
  data,
})